import Head from "next/head";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  keywords?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  section?: string;
  tags?: string[];
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  canonical,
  ogImage = "https://www.priceworth.com.au/category.webp",
  ogType = "website",
  keywords,
  author = "Priceworth Furniture",
  publishedTime,
  modifiedTime,
  section,
  tags = []
}) => {
  const fullTitle = title.includes("Priceworth") ? title : `${title} | Priceworth Furniture`;
  const fullDescription = description.length > 160 ? description.substring(0, 157) + "..." : description;
  
  return (
    <Head>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="author" content={author} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Priceworth Furniture" />
      {canonical && <meta property="og:url" content={canonical} />}
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Article specific meta tags */}
      {ogType === "article" && (
        <>
          {publishedTime && <meta property="article:published_time" content={publishedTime} />}
          {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
          {section && <meta property="article:section" content={section} />}
          {tags.map((tag, index) => (
            <meta key={index} property="article:tag" content={tag} />
          ))}
        </>
      )}
      
      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="format-detection" content="telephone=no" />
      
      {/* Language and Region */}
      <meta property="og:locale" content="en_AU" />
      <meta name="geo.region" content="AU-NSW" />
      <meta name="geo.placename" content="Australia" />
      
      {/* Business Information */}
      <meta name="business:contact_data:street_address" content="Australia" />
      <meta name="business:contact_data:country_name" content="Australia" />
      <meta name="business:contact_data:phone_number" content="+61 425 898 876" />
      <meta name="business:contact_data:email" content="priceworth2009@gmail.com" />
    </Head>
  );
};

export default SEOHead; 